import { useMemo } from 'react'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

const isInactive = [
  { key: '1', value: 'Yes' },
  { key: '0', value: 'No' },
]
export const usePartnerShip = () => {
  const activeSource = useMemo(
    () =>
      new Crud({
        fetcher: new Static(isInactive),
        keyField: 'key',
        defaultPaging: {
          page: 0,
          pageSize: 2,
        },
      }),
    []
  )
  return { activeSource }
}
